import axiosInstance from "../modules/axiosInstance";

class DeviceSessionsService {
  async getStats(params = {}) {
    const { data } = await axiosInstance.get("api/device-sessions/stats", {
      params,
    });
    return data?.data ?? data;
  }

  async getUserSessions(userId, params = {}) {
    const { data } = await axiosInstance.get(`api/device-sessions/user/${userId}`, {
      params,
    });
    return data?.data ?? data;
  }

  async getUserStats(userId) {
    const { data } = await axiosInstance.get(
      `api/device-sessions/user/${userId}/stats`
    );
    return data?.data ?? data;
  }
}

export default new DeviceSessionsService();


